export enum CopyDprDefaultOptions {
  Activities = 1,
  Personnel,
  Weather,
  Consumables,
  HSE,
  Summary,
  Appendix,
  Forecast,
  HiddenFreeTextFields,
  ProgressCountWithTarget,
  StatusTracker,
  ProgressCountWithoutTarget,
}
